<template>
    <div id="FormFileUpload">
        <div :class="`form-file-upload  file-upload-align-${align}`">
            <h3>{{ fieldLabelFile }}</h3>
            <div style="width: 100%">
                <div class="upload-container">
                    <label for="file-upload" class="file-label">
                        <md-icon class="upload-icon">cloud_upload</md-icon>
                        <p>{{ altLabelOne }}</p>
                    </label>
                </div>
                <label>{{ altLabelTwo }}</label>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    name: "FileUpload",
    props: {
        item: Object,
        fieldLabelFile: String,
        align: String,
        altLabelOne: String,
        altLabelTwo: String,
    },
    data() {
        return {
            localFieldLabelFile: this.fieldLabelFile || "",
            localAlign: this.align || "",
            localAltLabelOne: this.altLabelOne || "",
            localAltLabelTwo: this.altLabelTwo || "",
        };
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
.file-upload-align-left {
    display: flex !important;
}

.file-upload-align-right {
    display: flex !important;

    h3 {
        text-align: right !important;
        margin-right: 5px !important;
    }
}
#FormFileUpload {
    .form-file-upload {
        text-align: center;

        h3 {
            font-size: 24px;
            margin-bottom: 16px;
            text-align: left;
        }

        .upload-container {
            border: 2px dashed #ccc;
            padding: 20px;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;

            .file-input {
                display: none;
            }

            .file-label {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;

                .upload-icon {
                    width: 40px;
                    height: 40px;
                    background-size: contain;
                    margin-bottom: 8px;
                }

                p {
                    font-size: 18px;
                    font-weight: bold;
                    margin: 0;
                }

                span {
                    font-size: 14px;
                    color: #888;
                }
            }
        }
    }
}
</style>
